import React from 'react';
import { Route } from 'react-router';
export default (
  <Route
    path="management/:categoryId"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyNews/screens/Admin/router.js
 **/